import { render, staticRenderFns } from "./normal_view.vue?vue&type=template&id=f59ca8d6&"
import script from "./normal_view.vue?vue&type=script&lang=js&"
export * from "./normal_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports